import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable, catchError, throwError } from 'rxjs';
import { ToastService } from './toast.service';
import { Router } from '@angular/router';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token: string | null = null;
    if (isPlatformBrowser(this.platformId)) {
      token = localStorage.getItem('token');
    }

    if (token) {
      req = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });
    }

    req = req.clone({
      headers: req.headers.set('Access-Control-Allow-Origin', '*'),
    });

    req = req.clone({ params: req.params.set('time_offset', new Date().getTimezoneOffset()) });

    return next.handle(req).pipe(
      catchError((error) => {
        console.error('HTTP Error:', error);
        if (error.status === 401 && !req.url.includes('app_init')) {
          this.router.navigate(['/']);
          this.toastService.ErrorToast('Unauthorized');
        } else if (error.status === 500) {
          // this.toastService.ErrorToast('Oops, Something went wrong!');
        }
        return throwError(() => error);
      })
    );
  }
}
